var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import serialize from 'serialize-javascript';
export var SerializeData = function (_a) {
    var data = _a.data, name = _a.name, props = __rest(_a, ["data", "name"]);
    return (React.createElement("script", __assign({ defer: true }, props, { dangerouslySetInnerHTML: {
            __html: "window._" + name.toUpperCase() + "_ = " + serialize(data),
        } })));
};
export var getSerializedData = function (name, remove) {
    if (remove === void 0) { remove = true; }
    var data = window["_" + name.toUpperCase() + "_"];
    if (remove) {
        delete window["_" + name.toUpperCase() + "_"];
    }
    return data;
};
//# sourceMappingURL=serializeData.js.map